import React from 'react';

import {DATE_FORMAT_URL} from '../../../../data/constants/datetime';
import {eventMomentFactory} from '../../../../data/misc/eventMomentFactory';
import {useI18n} from '../../../../data/hooks/i18nHooks';
import Link from '../../../elements/Link';
import SandboxedContent from '../../../SandboxedContent/SandboxedContent';
import {useScheduleSessionRoute} from '../../../../data/hooks/routingHooks';
import { SCHEDULE_SESSION_DISPLAY_TYPE_ROUND } from 'common-data-handling';

// TODO: this could use come cleanup

function handleItemClicked(event, programStart, programId) {
    app.history.push(['/events', event.id, 'schedule', eventMomentFactory(event, programStart).format(DATE_FORMAT_URL), programId].join('/'));
    app.store.dispatch(app.actions.ui.sidePanel.maximize(false));
}

const WaitingRoomProgram = props => {
    const {event, session} = props,
        i18n = useI18n(),
        descriptionEl = `<div style="max-height: 135px; overflow: hidden; line-height:150%;" >${session.description}</div>`,
        href = useScheduleSessionRoute(event.id, session.id);

    return (
        <div className="WaitingRoomProgram">
            <h2>{session.name}</h2>
            <div>
                <SandboxedContent content={descriptionEl} fitHeightToContents style={{marginTop: 0, marginLeft: -0, marginBottom: -10}} />
            </div>
            {session.display_type == SCHEDULE_SESSION_DISPLAY_TYPE_ROUND ? (
                <Link href={href}>{i18n['label.tap-to-select-workshop']}</Link>
            ) : (
                <Link onClick={() => handleItemClicked(event, session.start_local, session.id)}>{i18n['label.read-more']}</Link>
            )}
        </div>
    );
};

export default WaitingRoomProgram;
